<script setup>
import Button from '@/Components/Buttons/Button.vue';
import LinkButton from '@/Components/Buttons/Link.vue';
import {usePage} from '@inertiajs/vue3';
import {inject, onMounted, ref} from 'vue';

const answeredCookies = ref(true);

const route = inject('route');

function acceptCookies() {
    answeredCookies.value = true;
    localStorage.setItem('accepted-cookies', 'true');
}

function declineCookies() {
    answeredCookies.value = true;
    localStorage.setItem('accepted-cookies', 'false');
}

onMounted(() => {
    answeredCookies.value = Object.hasOwn(localStorage, 'accepted-cookies');
});
</script>

<template>
    <div
        class="fixed bottom-0 z-30 w-full bg-grey-dark text-white transition-all duration-500"
        :class="{ 'translate-y-full ': answeredCookies }"
    >
        <div class="container flex flex-col items-center justify-between gap-5 py-5 lg:flex-row">
            <div class=" flex-1">
                {{ $t('Your experience on this site is enhanced by the use of cookies.') }}
            </div>
            <div class="flex w-full flex-1 flex-col justify-end gap-2 md:gap-4 lg:flex-row">
                <LinkButton
                    remove-width
                    white
                    :href="route('public.pages.show', usePage().props.commerceSettings.privacy_page_slug)"
                    :label="$t('More information')"
                    class="w-full md:w-60"
                />
                <Button
                    :label="$t('Decline cookies')"
                    remove-width
                    class="w-full md:w-60"
                    @click="declineCookies"
                />
                <Button
                    :label="$t('Allow cookies')"
                    remove-width
                    class="w-full md:w-60"
                    @click="acceptCookies"
                />
            </div>
        </div>
    </div>
</template>
